/* global debounce, localData */

const searchHeaderPosts = async (search, searchResultElem) => {
  if (!search?.value) {
    searchResultElem.classList.remove('is-active');
    return;
  }

  try {
    const response = await axios.post(
      localData.siteURL,
      {
        action: 'searchPostsHeader',
        keyword: search.value,
        lang: localData.lang,
        id: localData.id,
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    searchResultElem.classList.add('is-active');
    const searchResultInner = searchResultElem.querySelector('.header-search__results-inner');
    if (searchResultInner) {
      searchResultInner.innerHTML = response.data.html;
    }
  } catch (err) {
    console.error('Search failed:', err);
    searchResultElem.classList.remove('is-active');
  }
};

const searchField = document.querySelector('.header-search__input-field');

if (searchField) {
  const searchParentElem = searchField.closest('.header-search');
  const searchResultElem = searchParentElem.querySelector('.header-search__results');

  searchField.addEventListener(
    'keyup',
    debounce(async () => {
      await searchHeaderPosts(searchField, searchResultElem);
    }, 300),
  );

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      searchResultElem.classList.remove('is-active');
      searchField.blur();
    }
  });

  document.addEventListener('click', (evt) => {
    if (!searchParentElem.contains(evt.target)) {
      searchResultElem.classList.remove('is-active');
      searchField.blur();
    }
  });
}
